/* eslint-disable */
import AssessApk from './state';

export default {
  AssessApk,
};
